import styles from './company-search.module.scss';
import { Option, Skeleton, VirtualizedSelect, IContactType } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface CompanySearchProps {
  onChange: (id: string) => void,
  companyList: Array<IContactType>,
  selectedCompanyNumber?: string,
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>, currentList: Option[]) => void,
  isLoading?: boolean
}

export function CompanySearch(props: CompanySearchProps) {
  const existingCompanies = props.companyList.filter(c => !!c.number);
  const companyOptions: Array<Option> = existingCompanies.map(c => { return { id: c.number, label: `${c.name} ${c.department ? c.department : ""} (${c.number}) ${c.isBlocked ? "(Stoppet)" : ""}` } })
  const companyId = props.selectedCompanyNumber ? props.selectedCompanyNumber : props.companyList.find(c => c.number === props.selectedCompanyNumber)?.id;
  const selectedCompanyOption = companyOptions.find(c => c.id === companyId);
  return (
    <div>
      {props.companyList.length === 0 ?
        <Skeleton variant="rectangular" animation="wave" width={350} height={38} /> :
        <VirtualizedSelect
          options={companyOptions}
          handleSelect={props.onChange}
          selectedOption={selectedCompanyOption}
          onKeyDown={props.onKeyDown}
          isLoading={props.isLoading}
        />}
    </div>
  );
}

export default CompanySearch;